import React from 'react';

import './services.css';


import { faDesktop } from '@fortawesome/free-solid-svg-icons'

import {faShoppingCart} from '@fortawesome/free-solid-svg-icons'

import { faMobileAlt } from '@fortawesome/free-solid-svg-icons'

import { faCogs } from '@fortawesome/free-solid-svg-icons'

import ServiceItem from './serviceItem/serviceItem'



function Services() {
  return (
    <div className="services--meta--container">
     
      <div>
        <div className="services--header">
          Services
          </div>

        <div className="services--sub--header">
          We offer a variety of custom development services that will help you buisness
          </div>
      </div>
      
      <div className="services--container">
      <ServiceItem
        title="Website Development "
        icon={faDesktop}
        description="We know and love HTML and CSS, and we can make custom sites and animations to grow online traffic and your online presence stand out"
      >
      </ServiceItem>
      <ServiceItem
        title="E-Commerce"
        icon={faShoppingCart}

        description="We can setup and customize your shopify store, or integrate a payment proccesor like Paypal or Stripe into your app or website."
      ></ServiceItem>
      <ServiceItem
        title="Mobile App Development"
        icon={faMobileAlt}
        description="Want to take your web app, or e-commerce to the next level? 
                        What do people love more than your products? Their phones!
                        We can make any mobile app you can imagine"
      >
      </ServiceItem>
      <ServiceItem
        title="Automation"
        icon={faCogs}
        description="Do you need want some automation to help scale your growing buisness? 
                       We will develop customer servers to automate the bottlenecks keeping your growth  down?
                       Have a CRM solution in mind? We are experience building custom solutions on top of platforms like Salesforce and Zoho."
      >
      </ServiceItem>
      </div>

    </div>
  );
}

export default Services;
